/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WorkOrderDetailTicketDto
 */
export interface WorkOrderDetailTicketDto {
    /**
     * 
     * @type {string}
     * @memberof WorkOrderDetailTicketDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof WorkOrderDetailTicketDto
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof WorkOrderDetailTicketDto
     */
    type: WorkOrderDetailTicketDtoTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof WorkOrderDetailTicketDto
     */
    status: WorkOrderDetailTicketDtoStatusEnum;
    /**
     * 
     * @type {boolean}
     * @memberof WorkOrderDetailTicketDto
     */
    needsFollowUp: boolean;
    /**
     * 
     * @type {string}
     * @memberof WorkOrderDetailTicketDto
     */
    priority: WorkOrderDetailTicketDtoPriorityEnum;
    /**
     * 
     * @type {string}
     * @memberof WorkOrderDetailTicketDto
     */
    title: string;
    /**
     * 
     * @type {object}
     * @memberof WorkOrderDetailTicketDto
     */
    assetId?: object | null;
    /**
     * 
     * @type {object}
     * @memberof WorkOrderDetailTicketDto
     */
    siteId?: object | null;
    /**
     * 
     * @type {Date}
     * @memberof WorkOrderDetailTicketDto
     */
    dueAt?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof WorkOrderDetailTicketDto
     */
    membershipId: string;
    /**
     * 
     * @type {number}
     * @memberof WorkOrderDetailTicketDto
     */
    executionNumber: number;
    /**
     * 
     * @type {string}
     * @memberof WorkOrderDetailTicketDto
     */
    membershipStatus: WorkOrderDetailTicketDtoMembershipStatusEnum;
    /**
     * 
     * @type {object}
     * @memberof WorkOrderDetailTicketDto
     */
    taskId?: object | null;
    /**
     * 
     * @type {object}
     * @memberof WorkOrderDetailTicketDto
     */
    preventivePlanId?: object | null;
    /**
     * Preventive plan business code that generated this ticket
     * @type {object}
     * @memberof WorkOrderDetailTicketDto
     */
    planCode?: object | null;
    /**
     * Preventive plan display name
     * @type {object}
     * @memberof WorkOrderDetailTicketDto
     */
    planName?: object | null;
    /**
     * Concerned asset display name
     * @type {object}
     * @memberof WorkOrderDetailTicketDto
     */
    assetName?: object | null;
    /**
     * Concerned asset serial number
     * @type {object}
     * @memberof WorkOrderDetailTicketDto
     */
    assetSerialNumber?: object | null;
    /**
     * Latest visit execution result for Kanban chips (lean board — no report body)
     * @type {string}
     * @memberof WorkOrderDetailTicketDto
     */
    lastExecutionResult?: WorkOrderDetailTicketDtoLastExecutionResultEnum | null;
    /**
     * Linked incident for curative (corrective) tickets
     * @type {object}
     * @memberof WorkOrderDetailTicketDto
     */
    incidentId?: object | null;
    /**
     * Linked incident business code
     * @type {object}
     * @memberof WorkOrderDetailTicketDto
     */
    incidentCode?: object | null;
    /**
     * Linked incident title
     * @type {object}
     * @memberof WorkOrderDetailTicketDto
     */
    incidentTitle?: object | null;
    /**
     * Ordered checklist names from the linked library Task (empty when none)
     * @type {Array<string>}
     * @memberof WorkOrderDetailTicketDto
     */
    subtaskNames: Array<string>;
    /**
     * Latest visit report for this ticket when one exists
     * @type {object}
     * @memberof WorkOrderDetailTicketDto
     */
    report?: object | null;
}


/**
 * @export
 */
export const WorkOrderDetailTicketDtoTypeEnum = {
    Preventive: 'PREVENTIVE',
    Curative: 'CURATIVE'
} as const;
export type WorkOrderDetailTicketDtoTypeEnum = typeof WorkOrderDetailTicketDtoTypeEnum[keyof typeof WorkOrderDetailTicketDtoTypeEnum];

/**
 * @export
 */
export const WorkOrderDetailTicketDtoStatusEnum = {
    Open: 'OPEN',
    InProgress: 'IN_PROGRESS',
    Closed: 'CLOSED',
    Cancelled: 'CANCELLED'
} as const;
export type WorkOrderDetailTicketDtoStatusEnum = typeof WorkOrderDetailTicketDtoStatusEnum[keyof typeof WorkOrderDetailTicketDtoStatusEnum];

/**
 * @export
 */
export const WorkOrderDetailTicketDtoPriorityEnum = {
    Low: 'LOW',
    Medium: 'MEDIUM',
    High: 'HIGH'
} as const;
export type WorkOrderDetailTicketDtoPriorityEnum = typeof WorkOrderDetailTicketDtoPriorityEnum[keyof typeof WorkOrderDetailTicketDtoPriorityEnum];

/**
 * @export
 */
export const WorkOrderDetailTicketDtoMembershipStatusEnum = {
    Active: 'ACTIVE',
    MovedOut: 'MOVED_OUT',
    Cancelled: 'CANCELLED'
} as const;
export type WorkOrderDetailTicketDtoMembershipStatusEnum = typeof WorkOrderDetailTicketDtoMembershipStatusEnum[keyof typeof WorkOrderDetailTicketDtoMembershipStatusEnum];

/**
 * @export
 */
export const WorkOrderDetailTicketDtoLastExecutionResultEnum = {
    CompletedOk: 'COMPLETED_OK',
    CompletedWithIssue: 'COMPLETED_WITH_ISSUE',
    NotDone: 'NOT_DONE',
    Cancelled: 'CANCELLED'
} as const;
export type WorkOrderDetailTicketDtoLastExecutionResultEnum = typeof WorkOrderDetailTicketDtoLastExecutionResultEnum[keyof typeof WorkOrderDetailTicketDtoLastExecutionResultEnum];


/**
 * Check if a given object implements the WorkOrderDetailTicketDto interface.
 */
export function instanceOfWorkOrderDetailTicketDto(value: object): value is WorkOrderDetailTicketDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('needsFollowUp' in value) || value['needsFollowUp'] === undefined) return false;
    if (!('priority' in value) || value['priority'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('membershipId' in value) || value['membershipId'] === undefined) return false;
    if (!('executionNumber' in value) || value['executionNumber'] === undefined) return false;
    if (!('membershipStatus' in value) || value['membershipStatus'] === undefined) return false;
    if (!('subtaskNames' in value) || value['subtaskNames'] === undefined) return false;
    return true;
}

export function WorkOrderDetailTicketDtoFromJSON(json: any): WorkOrderDetailTicketDto {
    return WorkOrderDetailTicketDtoFromJSONTyped(json, false);
}

export function WorkOrderDetailTicketDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkOrderDetailTicketDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'code': json['code'],
        'type': json['type'],
        'status': json['status'],
        'needsFollowUp': json['needsFollowUp'],
        'priority': json['priority'],
        'title': json['title'],
        'assetId': json['assetId'] == null ? undefined : json['assetId'],
        'siteId': json['siteId'] == null ? undefined : json['siteId'],
        'dueAt': json['dueAt'] == null ? undefined : (new Date(json['dueAt'])),
        'membershipId': json['membershipId'],
        'executionNumber': json['executionNumber'],
        'membershipStatus': json['membershipStatus'],
        'taskId': json['taskId'] == null ? undefined : json['taskId'],
        'preventivePlanId': json['preventivePlanId'] == null ? undefined : json['preventivePlanId'],
        'planCode': json['planCode'] == null ? undefined : json['planCode'],
        'planName': json['planName'] == null ? undefined : json['planName'],
        'assetName': json['assetName'] == null ? undefined : json['assetName'],
        'assetSerialNumber': json['assetSerialNumber'] == null ? undefined : json['assetSerialNumber'],
        'lastExecutionResult': json['lastExecutionResult'] == null ? undefined : json['lastExecutionResult'],
        'incidentId': json['incidentId'] == null ? undefined : json['incidentId'],
        'incidentCode': json['incidentCode'] == null ? undefined : json['incidentCode'],
        'incidentTitle': json['incidentTitle'] == null ? undefined : json['incidentTitle'],
        'subtaskNames': json['subtaskNames'],
        'report': json['report'] == null ? undefined : json['report'],
    };
}

export function WorkOrderDetailTicketDtoToJSON(json: any): WorkOrderDetailTicketDto {
    return WorkOrderDetailTicketDtoToJSONTyped(json, false);
}

export function WorkOrderDetailTicketDtoToJSONTyped(value?: WorkOrderDetailTicketDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'code': value['code'],
        'type': value['type'],
        'status': value['status'],
        'needsFollowUp': value['needsFollowUp'],
        'priority': value['priority'],
        'title': value['title'],
        'assetId': value['assetId'],
        'siteId': value['siteId'],
        'dueAt': value['dueAt'] == null ? value['dueAt'] : value['dueAt'].toISOString(),
        'membershipId': value['membershipId'],
        'executionNumber': value['executionNumber'],
        'membershipStatus': value['membershipStatus'],
        'taskId': value['taskId'],
        'preventivePlanId': value['preventivePlanId'],
        'planCode': value['planCode'],
        'planName': value['planName'],
        'assetName': value['assetName'],
        'assetSerialNumber': value['assetSerialNumber'],
        'lastExecutionResult': value['lastExecutionResult'],
        'incidentId': value['incidentId'],
        'incidentCode': value['incidentCode'],
        'incidentTitle': value['incidentTitle'],
        'subtaskNames': value['subtaskNames'],
        'report': value['report'],
    };
}

